import React from "react";
import {Link} from "react-router-dom";
import routes from "../../consts/routes.json";
import logogui from "../../images/logo_gui.png";
import logoh2 from "../../images/logo_h2.png";
import {getCurrentUser, logout} from "../../services/JwtService";

function PageHeader({history}) {
    const user = getCurrentUser();
    return (
        <header role="banner">
            <Link to={routes.STARTSEITE} id="logo" className="fl logo">
                <img src={logoh2} alt="zur Startseite"/>
            </Link>
            <Link to="" className="fr logo">
                <img src={logogui} alt="eAbwasser-Logo"/>
            </Link>
            <ul id="sysnavi">
                {user && (
                    <li className="icon icon-user">
                        <Link to={routes.PROFIL}>{user.vorname + " " + user.name}</Link>
                    </li>
                )}
                {getCurrentUser() && <li className="icon icon-android-mail">
                    <a href={"mailto:" + process.env.REACT_APP_SUPPORT_EMAIL_ADDRESS + "?subject=Anfrage eAbwasser:"}>Support</a>
                </li>}
                {getCurrentUser() && <li className="icon icon-help-circled">
                    <a target={"_blank"} rel="noopener noreferrer" href={process.env.REACT_APP_DOKUWIKI_HOST}>
                        Hilfe
                    </a>
                </li>}
                {user && (
                    <li
                        className="icon icon-locked"
                        onClick={() => {
                            logout();
                            history.push(routes.LOGIN);
                        }}
                    >
                        <u> Abmelden</u>
                    </li>
                )}
            </ul>
        </header>
    );
}

export default PageHeader;
